import { getTextDirection } from '#pplx/frontend/i18n/core.js';
import { useIntl } from 'react-intl';
export const useIsRTL = () => {
    const { locale } = useIntl();
    return getTextDirection(locale) === 'rtl';
};
//# sourceMappingURL=useIsRTL.js.map